/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Wizard_Tools_TitleInputs */



/**
* | output |
* | --- |
* | "What can {name} use?" |
*
* @param {Agent_Wizard_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_tools_title = /** @type {((inputs: Agent_Wizard_Tools_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Tools_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Was darf ${i?.name} nutzen?`)
	return /** @type {LocalizedString} */ (`What can ${i?.name} use?`)
});